/*jshint esversion: 6 */
import store from '@/store/index';
import UltraRoute from '@/router/components/UltraRoute.js';
import WorkPackageEditorModule from '@/router/modules/WorkPackageEditor.module.js';
import WorkPackageImageZoom from '@/router/modules/WorkPackageImageZoom.module.js';
import WorkPackageInfoBox from '@/router/modules/WorkPackageInfoBox.module.js';

function Template(payload) {
  let route = UltraRoute({
    name: `${payload.location}SequenceEditor`,
    path: ':sequence_id',
    folder: 'WorkBenchRework',
    file: 'WorkBenchSequenceEditor',
    auth:true,
    props: (route) => {
      return {
        read_only: ['custom', 'company'].includes(route.params.template_type)?false:true,
        create: route.params.sequence_id === 'create'?true:false,
        location: payload.location,
        sequence_id: route.params.sequence_id,
        template_type: route.params.template_type
      };
    },
    children: [
      UltraRoute({
        name: `${payload.location}SequenceWaggon`,
        path: 'waggons/:waggon_id',
        folder: 'WorkBenchRework',
        file: 'WorkBenchSequenceWaggon',
        auth:true,
        props: (route) => {
          return {
            read_only: ['custom', 'company'].includes(route.params.template_type)?false:true,
            create: route.params.sequence_id === 'create'?true:false,
            waggon_id: parseInt(route.params.waggon_id),
            location: payload.location,
          };
        },
        redirect: `${payload.location}SequenceWaggonWorkPackageAdd`,
        children: [
          UltraRoute({
            name: `${payload.location}SequenceWaggonWorkPackage`,
            path: 'workpackages/:workpackage_id',
            folder: 'WorkBenchRework',
            file: 'WorkBenchSequenceWaggonWorkPackage',
            auth:true,
            props: (route) => {
              return {
                read_only: ['custom', 'company'].includes(route.params.template_type)?false:true,
                create: route.params.sequence_id === 'create'?true:false,
                waggon_id: parseInt(route.params.waggon_id),
                work_package_id: parseInt(route.params.workpackage_id),
                location: payload.location,
              };
            },
            before_enter: (to, from, next) => {
              if (to.params.sequence_id !== 'create') {
                let prefix = '';
                switch (to.params.template_type) {
                  case 'custom':
                    break;
                  case 'company':
                    prefix = 'b';
                    break;
                  case 'community':
                    prefix = 'c';
                    break;
                }
                let url = [
                  {[`${prefix}sequences`]: to.params.sequence_id},
                  {[`${prefix}swaggons`]: to.params.waggon_id},
                  {[`${prefix}sworkpackages`]: to.params.workpackage_id},
                  {showWithEntitiesNormalized: ''}
                ];
                if (prefix === 'b') {
                  url = [
                    {[`${prefix}sequences`]: to.params.sequence_id},
                    {[`${prefix}swaggons`]: to.params.waggon_id},
                    {[`${prefix}sworkpackages`]: to.params.workpackage_id},
                    {showWithEntitiesNormalized: ''}
                  ];
                }
                store.dispatch('WorkBench/requestWBObject', {
                  url: url,
                  template_type: to.params.template_type
                }).then(() => next())
              } else {
                next();
              }
            },
            children: [
              WorkPackageEditorModule({
                path: 'edit',
                location: `${payload.location}SequenceWaggon`,
                read_only: false,
                nav_back: `${payload.location}SequenceWaggonWorkPackage`,
              }),
              WorkPackageImageZoom(Object.assign(JSON.parse(JSON.stringify(payload)), {
                location: `${payload.location}SequenceWaggon`,
                close: `${payload.location}SequenceWaggonWorkPackage`
              }))
            ]
          }),
          UltraRoute({
            name: `${payload.location}SequenceWaggonWorkPackageAdd`,
            path: 'addworkpackage',
            folder: 'WorkBenchRework',
            file: 'WorkBenchSequenceWaggonWorkPackageAdd',
            auth:true,
            props: (route) => {
              return {
                waggon_id: parseInt(route.params.waggon_id),
                create: route.params.sequence_id === 'create'?true:false,
                location: payload.location,

              };
            },
            children: [
              WorkPackageInfoBox(Object.assign(JSON.parse(JSON.stringify(payload)), {
                location: `${payload.location}SequenceWaggon`
              })),
              WorkPackageEditorModule({
                path: ':workpackage_id',
                location: `${payload.location}SequenceWaggonWorkPackageAdd`,
                read_only: false,
                nav_back: `${payload.location}SequenceWaggonWorkPackageAdd`,
              }),
            ]
          }),
        ]
      }),
      UltraRoute({
        name: `${payload.location}SequenceWaggonAdd`,
        path: 'addwaggon',
        folder: 'WorkBenchRework',
        file: 'WorkBenchSequenceWaggonAdd',
        auth:true,
        props: (route) => {
          return {
            read_only: ['custom', 'company'].includes(route.params.template_type)?false:true,
            create: route.params.sequence_id === 'create'?true:false,
            sequence_id: route.params.sequence_id,
            sequence_index: route.params.sequence_index || 0,
            add_before: route.params.add_before || false,
            location: payload.location,
          };
        },
        children: []
      }),
      UltraRoute({
        name: `${payload.location}RecommendedWaggon`,
        path: 'recommendedwaggons/:rec_waggon_index',
        folder: 'WorkBenchRework/WorkBenchWorkPackageInfoBox',
        file: 'WorkBenchWorkPackageInfoBox',
        auth:true,
        props: (route) => {
          return {
            read_only: ['custom', 'company'].includes(route.params.template_type)?false:true,
            create: route.params.sequence_id === 'create'?true:false,
            sequence_id: route.params.sequence_id,
            sequence_index: route.params.sequence_index || 0,
            add_before: route.params.add_before || false,
            location: payload.location,
          };
        },
        children: []
      }),
    ]
  });
  return route;
}
export default Template;
